import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from "@angular/core";

@Component({
  selector: "picture-selector",
  templateUrl: "./picture-selector.component.html",
  styleUrls: ["./picture-selector.component.scss"]
})
export class PictureSelectorComponent implements OnInit, OnDestroy {
  fullscreen = false;
  displayVideoContainer = false;

  private imageData: string | null;
  @Input() public imageUrl: string | null = null;
  get url() {
    return this.imageData || this.imageUrl;
  }
  @Input() public hasImage = true;

  @Input() public useCamera = true;
  @Input() public useUpload = true;

  @Output() public upload = new EventEmitter<string>();
  @Output() public filename = new EventEmitter<string>();
  @Output() public delete = new EventEmitter<void>();

  @Input() public accept = "image/png, image/gif, image/jpeg";

  constructor() {}

  ngOnInit(): void {}
  ngOnDestroy() {
    this.stopCamera();
  }

  askDeleteImage;
  deleteImage() {
    if (!this.askDeleteImage) {
      this.askDeleteImage = true;
    } else {
      this.askDeleteImage = false;
      this.hasImage = false;
      this.imageData = null;
      this.delete.emit();
    }
  }

  @ViewChild("video")
  public video: ElementRef;
  startCamera() {
    this.setupDevices();
    this.displayVideoContainer = true;
  }
  captureCameraImage() {
    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");
    ctx.canvas.width = this.video.nativeElement.videoWidth;
    ctx.canvas.height = this.video.nativeElement.videoHeight;

    ctx.drawImage(
      this.video.nativeElement,
      0,
      0,
      this.video.nativeElement.videoWidth,
      this.video.nativeElement.videoHeight
    );
    this.saveImage(ctx.canvas.toDataURL("image/png", 0.9));
    this.stopCamera();
  }
  stopCamera() {
    this.displayVideoContainer = false;
    if (this.stream)
      this.stream.getTracks().forEach(function (track) {
        track.stop();
      });
  }

  private stream: any;
  async setupDevices() {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      try {
        this.stream = await navigator.mediaDevices.getUserMedia({
          video: {
            facingMode: "environment"
          }
        });
        if (this.stream) {
          this.video.nativeElement.srcObject = this.stream;
          this.video.nativeElement.play();
        } else {
          console.error("no video output device found");
        }
      } catch (e) {
        console.error(e);
      }
    }
  }

  @ViewChild("fileUpload") fileUpload: ElementRef;
  private files: any[] = [];
  async startUpload() {
    const fileUpload = this.fileUpload.nativeElement;
    this.fileUpload.nativeElement.value = "";
    this.files = [];
    fileUpload.onchange = () => {
      for (let index = 0; index < fileUpload.files.length; index++) {
        const file = fileUpload.files[index];
        this.files.push({ data: file, inProgress: false, progress: 0 });
      }
      this.fileUpload.nativeElement.value = "";
      this.uploadFiles();
    };
    fileUpload.click();
  }
  filesLoading = false;
  filesUploaded = false;
  fileUploadedCount = 0;
  async uploadFiles() {
    this.filesLoading = true;
    await Promise.all(this.files.map(this.uploadFile.bind(this)));
    this.filesLoading = false;
    this.filesUploaded = true;
  }
  uploading = false;
  uploaded = false;
  count = 0;
  async uploadFile(file: any) {
    return new Promise<void>((resolve) => {
      const reader = new FileReader();

      reader.addEventListener(
        "load",
        async () => {
          this.uploaded = false;
          this.uploading = false;
          this.saveImage(reader.result.toString());
          this.filename.emit(file.data.name);

          resolve();
        },
        false
      );

      if (file) {
        reader.readAsDataURL(file.data);
      }
    });
  }

  private saveImage(data: any) {
    this.upload.emit(data);
    this.imageData = data;
    this.hasImage = true;
  }
}
